import { render, staticRenderFns } from "./ActivePlans.vue?vue&type=template&id=63949f68&scoped=true"
import script from "./ActivePlans.vue?vue&type=script&lang=js"
export * from "./ActivePlans.vue?vue&type=script&lang=js"
import style0 from "./ActivePlans.vue?vue&type=style&index=0&id=63949f68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63949f68",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
